import {
  QueryFunction,
  QueryKey,
  useQuery,
  UseQueryOptions,
} from '@tanstack/react-query';
import { App } from 'antd';
import { handleError } from 'api';
import {
  AssignClientsResponse,
  AssignedClientPendingDocumentList,
  AssignedClientsApiService,
} from 'features/assigned-clients/api/assign-clients-api.service';
import qs from 'qs';
const { adminRequestDocumentList } = AssignedClientsApiService();

const getDocumentCategoryQuery = (
  params: AssignedClientPendingDocumentList,
  options?: UseQueryOptions<AssignClientsResponse>,
): {
  queryKey: QueryKey;
  queryFn: QueryFunction<AssignClientsResponse>;
  options?: UseQueryOptions<AssignClientsResponse>;
} => ({
  queryKey: ['RequestedDocumentList', params.CompanyId],
  queryFn: ({ signal }) =>
    adminRequestDocumentList(params, {
      config: {
        signal,
        paramsSerializer: {
          serialize: (queryParams) =>
            qs.stringify(queryParams, {
              arrayFormat: 'repeat',
              encode: false,
            }),
        },
      },
    }),
  ...options,
});

export const useGetRequestedDocumentList = (
  params: any,
  options?: UseQueryOptions<AssignClientsResponse>,
) => {
  const { message } = App.useApp();

  return useQuery<AssignClientsResponse, Error>(
    getDocumentCategoryQuery(params, {
      onError: (error: unknown) => {
        const uiMessage = handleError(error);

        message.error(uiMessage);
      },
      ...options,
    }),
  );
};
